import React, { createContext, useContext } from "react";

interface WorkspaceContextType {
  workspaceId: string | null;
}

const WorkspaceContext = createContext<WorkspaceContextType>({
  workspaceId: null,
});

export const useWorkspaceContext = () => {
  return useContext(WorkspaceContext);
};

export const WorkspaceProvider: React.FC<{
  workspaceId: string | null;
  children: React.ReactNode;
}> = ({ workspaceId, children }) => {
  return (
    <WorkspaceContext.Provider value={{ workspaceId }}>
      {children}
    </WorkspaceContext.Provider>
  );
};
